import script from "./forgotPassword.vue?vue&type=script&setup=true&lang=js"
export * from "./forgotPassword.vue?vue&type=script&setup=true&lang=js"

import "./forgotPassword.vue?vue&type=style&index=0&id=28a71058&lang=css"

const __exports__ = script;

export default __exports__